export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-16.8514d31c.jpg";